import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function InvoicesGlobalProvider({ children }) {
  useInjectSaga({ key: 'invoicesGlobalProvider', saga });
  useInjectReducer({ key: 'invoicesGlobalProvider', reducer });

  return React.Children.only(children);
}

InvoicesGlobalProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withInvoicesGlobal } from './withInvoicesGlobal';
export default compose(withConnect, memo)(InvoicesGlobalProvider);
